import { render, staticRenderFns } from "./drawer-message-info.vue?vue&type=template&id=02561c89&scoped=true&"
import script from "./drawer-message-info.vue?vue&type=script&lang=js&"
export * from "./drawer-message-info.vue?vue&type=script&lang=js&"
import style0 from "./drawer-message-info.vue?vue&type=style&index=0&id=02561c89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02561c89",
  null
  
)

export default component.exports